import { COURSE_BUNDLES_API } from 'modules/courses/bundles/api/course-bundles-api'
import {
  CourseBundleItemInterface,
  CourseBundleItemUpdateInterface,
} from 'modules/courses/bundles/course-bundle/types/course-bundle-interface'
import httpClient from 'shared/utils/http-client'

export const COURSE_BUNDLE_ITEM_API = '/api/dashboard/customer/membership/course-bundles/item'

export const removeCourseBundleItem = (id: number) =>
  httpClient.delete(`${COURSE_BUNDLE_ITEM_API}/${id}/remove`)

export const updateCourseBundleItem = (
  data: Pick<CourseBundleItemInterface, 'delayBeforeStart'>,
  id: number,
) => httpClient.put<CourseBundleItemInterface>(`${COURSE_BUNDLE_ITEM_API}/${id}/update`, data)

export const changeCourseBundleItemPosition = (id: number, data: { position: number }) =>
  httpClient.put<CourseBundleItemInterface>(`${COURSE_BUNDLE_ITEM_API}/${id}/update-position`, data)

export const addCourse = (id: string, data: Pick<CourseBundleItemUpdateInterface, 'course'>) =>
  httpClient.post<CourseBundleItemInterface>(`${COURSE_BUNDLES_API}/${id}/add-course`, data)
